export default __webpack_public_path__ + "static/pff-41a0fe6d8d68b74ce6fbef0841eecda0.png";